var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleInferior3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 740,
    height: 44,
    viewBox: "0 0 740 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M739 3C739 1.89543 738.105 1 737 1H3C1.89545 1 1 1.89543 1 3V28C1 29.0906 1.91382 30.0001 3.03278 30.0005C147.108 30.0452 263.146 33.2715 376.886 36.4981L382.604 36.6604C494.37 39.8321 604.33 42.9526 736.972 42.9995C738.088 42.9999 739 42.0923 739 41V3Z",
    fill: "white",
    stroke: "#EBEFF6",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleInferior3);
export default __webpack_public_path__ + "static/media/rectangleInferior3.6ed336a82936e3640281a3f7acbef6f5.svg";
export { ForwardRef as ReactComponent };